import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ProjectsSortBy = 'projectName' | 'address' | 'createdAt' | 'lastModified'
export type ProjectsSortOrder = 'asc' | 'desc'
export type ProjectsDisplayMode = 'grid' | 'list'

export interface ProjectsUiState {
  searchText: string,
  sortBy: ProjectsSortBy;
  sortOrder: ProjectsSortOrder;
  displayMode: ProjectsDisplayMode;
  startDate: string | null;
  endDate: string | null;
}

const initialState: ProjectsUiState = {
  searchText: '',
  sortBy: 'lastModified',
  sortOrder: 'asc',
  displayMode: 'list',
  startDate: null,
  endDate: null,
}

export const projectsUiSlice = createSlice({
  name: 'projectsUi',
  initialState,
  reducers: {
    setSortBy: (
        state,
        action: PayloadAction<{ sortBy: ProjectsSortBy; sortOrder: ProjectsSortOrder }>
    ) => {
      state.sortBy = action.payload.sortBy;
      state.sortOrder = action.payload.sortOrder;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setDisplayMode: (state, action: PayloadAction<ProjectsDisplayMode>) => {
      state.displayMode = action.payload;
    },
    setStartDate: (state, action: PayloadAction<string | null>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<string | null>) => {
      state.endDate = action.payload;
    },
  }
})
